(function () {
  'use strict';

  /* ========================================================================
     TMC Menopause Quiz
     Flow: intro -> quiz (9 Qs) -> email -> results
     ======================================================================== */

  var PRODUCTS = {
    foundation: {
      name: 'Foundation',
      handle: 'foundation',
      variantId: 45071549694256,
      sellingPlanId: 688791617840,
      tagline: 'Balance from the inside out',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_foundation.jpg',
      benefit:
        'Your essential base layer. Foundation is the formula you need to improve all the most common symptoms throughout the stages of menopause. A balanced brain and body formula to support hormone health and ease hot flushes and night sweats.',
    },
    mood: {
      name: 'Mood',
      handle: 'mood',
      variantId: 45071560933680,
      sellingPlanId: 688791945520,
      tagline: 'Emotional balance and calm',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_mood.jpg',
      benefit:
        "Calm the emotional storm. Mood's blend of saffron, lavender, and St. John's Wort may help support a more balanced mood, ease feelings of anxiety, and help you feel more like yourself again.",
    },
    sleep: {
      name: 'Sleep',
      handle: 'sleep',
      variantId: 45071562834224,
      sellingPlanId: 688791683376,
      tagline: 'Deep, refreshing rest',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_sleep.jpg',
      benefit:
        "Deeper, more restorative sleep. Sleep's formula of passionflower, California poppy, and magnesium may help you fall asleep faster, stay asleep longer, and wake actually feeling rested. Because everything is harder when you're exhausted.",
    },
    libido: {
      name: 'Libido',
      handle: 'libido',
      variantId: 45071556378928,
      sellingPlanId: 688791978288,
      tagline: 'Reconnect with desire and comfort',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_libido.jpg',
      benefit:
        'Reconnect with desire and comfort. Libido may help ease vaginal dryness, support arousal, and reignite intimacy. These changes are incredibly common during menopause, and entirely possible to support naturally.',
    },
    focus: {
      name: 'Focus',
      handle: 'focus',
      variantId: 45071549006128,
      sellingPlanId: 688791650608,
      tagline: 'Mental clarity and cognitive sharpness',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_focus.jpg',
      benefit:
        'Your brain, back online. Focus combines ginkgo biloba, bacopa, and schisandra to help cut through the fog, supporting memory, concentration, and the kind of mental clarity that makes you feel like yourself again.',
    },
    energy: {
      name: 'Energy',
      handle: 'energy',
      variantId: 45071547990320,
      sellingPlanId: 688791912752,
      tagline: 'Sustained vitality and stamina',
      image: 'https://themenopauseco.com/cdn/shop/files/product_shots_jars_energy.jpg',
      benefit:
        'Sustained energy, all day. Energy harnesses ashwagandha, Siberian ginseng, and CoQ10 to support your vitality, so you can stop hitting that afternoon wall and start thriving again. Best taken in the morning as it contains natural caffeine from guarana.',
    },
  };

  /* ---- Offer & pricing ----
     ADDEDFREE makes one item free once 2+ products are in the cart. On a
     subscription it applies to the first order only; ongoing orders keep the
     standard 15% off. Mirrored in custom-tmc-quiz-bar.js — keep both in sync. */
  var DISCOUNT_CODE = 'ADDEDFREE';
  var PRICE_ONETIME = 69.0;
  var PRICE_SUBSCRIPTION = 58.65;
  var FREE_ITEM_MIN_COUNT = 2;
  var FREE_SHIPPING_THRESHOLD = 99.0;

  /* Items the customer actually pays for once ADDEDFREE is applied. */
  function paidCount(recCount) {
    return recCount >= FREE_ITEM_MIN_COUNT ? recCount - 1 : recCount;
  }

  /* First-order total for the given purchase mode, after ADDEDFREE. */
  function orderTotal(recCount, subscribe) {
    return paidCount(recCount) * (subscribe ? PRICE_SUBSCRIPTION : PRICE_ONETIME);
  }

  /* Saving on the first order against paying full one-time price for everything. */
  function firstOrderSaving(recCount, subscribe) {
    return recCount * PRICE_ONETIME - orderTotal(recCount, subscribe);
  }

  /* Index of the line ADDEDFREE covers — always the lowest-priority pick.
     -1 when the plan is too small to qualify. */
  function freeIndex(recs) {
    return recs && recs.length >= FREE_ITEM_MIN_COUNT ? recs.length - 1 : -1;
  }

  /* The product ADDEDFREE covers. Null when the plan is too small to qualify. */
  function freeProduct(recs) {
    var i = freeIndex(recs);
    return i < 0 ? null : PRODUCTS[recs[i].product];
  }

  /* Line items for /cart/add.js. The free line stays one-time even in the
     subscribe flow: Skio does not honour ADDEDFREE on subscription lines, so
     the discount can only zero out a non-subscription line. Shared with
     buildEmailCartUrl so the AJAX cart and the emailed permalink can't drift. */
  function buildCartItems(recs, subscribe) {
    var free = freeIndex(recs);
    /* The free line is added first. Shopify discounts the cheapest eligible
       item and every formulation is $69, so it is always a tie — and the tie
       appears to fall to the earliest cart line. Putting the intended line
       there keeps ADDEDFREE off the subscription lines: a discounted
       subscription line gets converted to one-time, which would leave two
       one-time lines and the customer paying for the product we promised free. */
    var ordered = free < 0 ? recs : [recs[free]].concat(recs.slice(0, free));
    var freePos = free < 0 ? -1 : 0;
    return ordered.map(function (rec, i) {
      var p = PRODUCTS[rec.product];
      var item = { id: p.variantId, quantity: 1 };
      if (subscribe && i !== freePos) item.selling_plan = p.sellingPlanId;
      return item;
    });
  }

  /* Only claim free shipping when the post-discount total clears the threshold
     in both purchase modes, since the badge is shown once for both buttons. */
  function qualifiesForFreeShipping(recCount) {
    return (
      orderTotal(recCount, true) >= FREE_SHIPPING_THRESHOLD && orderTotal(recCount, false) >= FREE_SHIPPING_THRESHOLD
    );
  }

  /* Applies ADDEDFREE via Shopify's own discount route, which sets the
     discount_code cookie. Fire-and-forget — a failure must never stop the cart
     drawer opening. Redirects to /cart.js so we pull back a small JSON body
     rather than a full page. */
  function applyOfferCode() {
    return fetch('/discount/' + DISCOUNT_CODE + '?redirect=/cart.js', { credentials: 'same-origin' }).catch(
      function () {},
    );
  }

  /* Warms the discount_code cookie the moment a qualifying plan is on screen,
     so the session already carries ADDEDFREE before the customer clicks. The
     add-to-cart path applies it again afterwards: /cart/clear.js runs between
     these two points and we can't rely on a cleared cart keeping the code. */
  var offerCodePreloaded = false;
  function preloadOfferCode() {
    if (offerCodePreloaded || !results || freeIndex(results.recs) < 0) return;
    offerCodePreloaded = true;
    applyOfferCode();
  }

  var SYMPTOM_TAG_MAP = {
    hot_flushes: 'Hot Flushes',
    night_sweats: 'Hot Flushes',
    mood_swings: 'Mood',
    anxiety: 'Mood',
    sleep_issues: 'Sleep',
    fatigue: 'Energy',
    brain_fog: 'Brain Fog',
    low_libido: 'Libido',
  };

  var IMPACT_TAG_MAP = {
    physical: 'Symptom Management',
    emotional: 'Mood',
    sleep: 'Sleep',
    cognitive: 'Brain Fog',
    energy: 'Energy',
    intimacy: 'Libido',
  };

  var ARTICLE_DESCRIPTIONS = {
    'Hot Flushes': "What's really happening and how to ease the intensity",
    Sleep: 'How menopause disrupts sleep and what to do about it',
    Mood: 'Understanding the emotional shifts menopause brings',
    'Brain Fog': 'Why your thinking feels foggy and how to clear it',
    Energy: 'The hormonal roots of menopause fatigue — and real solutions',
    Libido: 'What changes, why, and how to reconnect with yourself',
    'Understanding Menopause': 'A clear guide to what your body is going through',
    Hormones: 'How your hormones are shifting and what that means for you',
    'Natural Remedies': 'Evidence-backed approaches to managing your symptoms',
    Wellness: 'Practical ways to support your whole-body health',
    'Symptom Management': 'Practical strategies for the symptoms affecting your day',
  };

  var QUIZ_QUESTIONS = [
    {
      id: 'stage',
      question: 'Where are you on your (peri)menopause journey?',
      subtitle: 'This helps us understand what stage of support you might need.',
      type: 'single',
      options: [
        {
          label: 'I think I might be starting perimenopause',
          value: 'early_peri',
          cohort: 'Early Perimenopause',
          weights: {},
        },
        {
          label: "I'm in the thick of perimenopause",
          value: 'active_peri',
          cohort: 'Active Perimenopause',
          weights: {},
        },
        {
          label: "I've reached menopause (no period for 12+ months)",
          value: 'menopause',
          cohort: 'Menopause',
          weights: {},
        },
        { label: "I'm post-menopause", value: 'post_meno', cohort: 'Post-Menopause', weights: {} },
        { label: "I'm not sure, something's changed", value: 'unsure', cohort: 'Exploring', weights: {} },
      ],
    },
    {
      id: 'top_symptoms',
      question: 'Which of these are you experiencing most?',
      subtitle: 'Select all that apply, there are no wrong answers here.',
      type: 'multi',
      options: [
        { label: 'Hot flushes', value: 'hot_flushes', weights: { foundation: 5 } },
        { label: 'Night sweats', value: 'night_sweats', weights: { foundation: 4, sleep: 2 } },
        { label: 'Mood swings or irritability', value: 'mood_swings', weights: { mood: 5, foundation: 1 } },
        { label: 'Anxiety or feeling overwhelmed', value: 'anxiety', weights: { mood: 4, sleep: 2 } },
        { label: 'Trouble sleeping', value: 'sleep_issues', weights: { sleep: 5, foundation: 2 } },
        { label: 'Low energy or fatigue', value: 'fatigue', weights: { energy: 5, sleep: 2 } },
        { label: 'Brain fog or poor memory', value: 'brain_fog', weights: { focus: 5, energy: 2 } },
        { label: 'Low libido or vaginal dryness', value: 'low_libido', weights: { libido: 5, mood: 1 } },
      ],
    },
    {
      id: 'biggest_impact',
      question: "What's having the biggest impact on your daily life?",
      subtitle: 'If you had to pick just one, which feels most disruptive?',
      type: 'single',
      options: [
        { label: 'Physical symptoms (flushes/sweats)', value: 'physical', weights: { foundation: 6 } },
        { label: 'Emotional ups and downs', value: 'emotional', weights: { mood: 6, foundation: 1 } },
        { label: 'Not sleeping well', value: 'sleep', weights: { sleep: 6, foundation: 1 } },
        { label: 'Feeling mentally foggy or forgetful', value: 'cognitive', weights: { focus: 6, energy: 1 } },
        { label: 'Having no energy', value: 'energy', weights: { energy: 6, sleep: 1 } },
        { label: 'Changes in intimacy/sexual wellbeing', value: 'intimacy', weights: { libido: 6, mood: 1 } },
      ],
    },
    {
      id: 'severity',
      question: 'How would you rate the severity of your symptoms?',
      subtitle: 'Drag the slider to where you feel you sit right now.',
      type: 'slider',
      min: 1,
      max: 10,
      defaultValue: 5,
      labels: { low: 'Mild', high: 'Severe' },
    },
    {
      id: 'sleep_quality',
      question: 'How would you describe your sleep in the last 4-8 weeks?',
      subtitle: "Sleep affects so much of how you feel, let's understand yours.",
      type: 'single',
      options: [
        { label: 'I sleep well most nights', value: 'good', weights: {} },
        { label: 'Fall asleep fine but wake during the night', value: 'waking', weights: { sleep: 4, foundation: 2 } },
        { label: 'I notice sleep is worse in the lead up to my period', value: 'onset', weights: { sleep: 5 } },
        { label: 'Rarely feel rested even after full night', value: 'unrefreshed', weights: { sleep: 4, energy: 3 } },
      ],
    },
    {
      id: 'energy_levels',
      question: 'How are your energy levels day to day?',
      subtitle: "Be honest, there's no right answer here.",
      type: 'single',
      options: [
        { label: 'Energised and capable most days', value: 'good', weights: {} },
        { label: 'Hit a wall by mid-afternoon', value: 'afternoon_crash', weights: { energy: 4, focus: 2 } },
        { label: 'Exhausted from the moment I wake up', value: 'exhausted', weights: { energy: 5, sleep: 2 } },
        {
          label: 'Energy is unpredictable, “wired but tired”',
          value: 'variable',
          weights: { energy: 3, foundation: 2 },
        },
      ],
    },
    {
      id: 'cognitive',
      question: 'Changes in thinking or memory?',
      subtitle: 'Brain fog is one of the most common, and least talked about, symptoms.',
      type: 'single',
      options: [
        { label: 'Mind feels as sharp as ever', value: 'sharp', weights: {} },
        { label: 'Sometimes lose train of thought', value: 'mild', weights: { focus: 3 } },
        { label: 'I am forgetting things more often', value: 'moderate', weights: { focus: 5, energy: 1 } },
        {
          label: 'Affecting confidence at work/daily life',
          value: 'severe',
          weights: { focus: 6, energy: 2, mood: 1 },
        },
      ],
    },
    {
      id: 'emotional',
      question: 'How are you feeling emotionally?',
      subtitle: 'Your emotional wellbeing matters just as much as the physical.',
      type: 'single',
      options: [
        { label: 'Emotionally steady most of the time', value: 'steady', weights: {} },
        { label: 'More ups and downs than usual', value: 'swings', weights: { mood: 4 } },
        { label: 'More anxious, irritable, or on edge', value: 'anxious', weights: { mood: 5, sleep: 1 } },
        { label: 'Feeling flat, low, or not quite myself', value: 'low', weights: { mood: 5, energy: 2 } },
      ],
    },
    {
      id: 'intimacy',
      question: 'Changes in sexual wellbeing?',
      subtitle: 'This is a safe space, these changes are very common and nothing to feel embarrassed about.',
      type: 'single',
      options: [
        { label: 'No changes', value: 'no_change', weights: {} },
        { label: 'Desire has decreased noticeably', value: 'low_desire', weights: { libido: 5, mood: 1 } },
        { label: 'Experienced dryness or discomfort', value: 'dryness', weights: { libido: 5 } },
        { label: 'Both desire and comfort have changed', value: 'both', weights: { libido: 6, mood: 1 } },
        { label: 'Prefer not to answer', value: 'skip', weights: {} },
      ],
    },
  ];

  /* ---- State ---- */
  var STORAGE_KEY = 'tmc_quiz_state_v2';
  var _prevStep = null;
  var _prevQIndex = -1;

  var currentStep = 'intro';
  var qIndex = 0;
  var answers = {};
  var email = '';
  var isFirstOrder = false;
  var results = null;

  function saveState() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          currentStep: currentStep,
          qIndex: qIndex,
          answers: answers,
          email: email,
          isFirstOrder: isFirstOrder,
          results: results,
        }),
      );
    } catch (e) {}
  }

  function loadState() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var s = JSON.parse(raw);
      currentStep = s.currentStep || 'intro';
      qIndex = s.qIndex || 0;
      answers = s.answers || {};
      email = s.email || '';
      isFirstOrder = s.isFirstOrder || false;
      results = s.results || null;
    } catch (e) {}
  }

  function clearState() {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
  }

  loadState();

  var root = document.getElementById('tmc-quiz-root');
  if (!root) return;

  /* ---- DOM helper ---- */
  function h(tag, attrs) {
    var children = Array.prototype.slice.call(arguments, 2);
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        var v = attrs[k];
        if (k === 'style' && typeof v === 'object') {
          Object.assign(el.style, v);
        } else if (k.indexOf('on') === 0 && typeof v === 'function') {
          el.addEventListener(k.slice(2).toLowerCase(), v);
        } else if (k === 'className') {
          el.className = v;
        } else if (k === 'innerHTML') {
          el.innerHTML = v;
        } else if (v === null || v === false || v === undefined) {
          /* skip */
        } else {
          el.setAttribute(k, v);
        }
      });
    }
    (function appendChildren(arr) {
      arr.forEach(function (c) {
        if (c == null || c === false) return;
        if (Array.isArray(c)) {
          appendChildren(c);
          return;
        }
        el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    })(children);
    return el;
  }

  /* ---- Scoring ---- */
  function calculateResults() {
    var scores = { foundation: 2, mood: 0, sleep: 0, libido: 0, focus: 0, energy: 0 };

    QUIZ_QUESTIONS.forEach(function (q) {
      if (q.type === 'slider') return;
      var answer = answers[q.id];
      if (!answer) return;
      if (q.type === 'multi' && Array.isArray(answer)) {
        answer.forEach(function (val) {
          var opt = q.options.find(function (o) {
            return o.value === val;
          });
          if (opt && opt.weights) {
            Object.keys(opt.weights).forEach(function (k) {
              scores[k] = (scores[k] || 0) + opt.weights[k];
            });
          }
        });
      } else {
        var opt = q.options.find(function (o) {
          return o.value === answer;
        });
        if (opt && opt.weights) {
          Object.keys(opt.weights).forEach(function (k) {
            scores[k] = (scores[k] || 0) + opt.weights[k];
          });
        }
      }
    });

    var sorted = Object.keys(scores)
      .filter(function (k) {
        return k !== 'foundation';
      })
      .map(function (k) {
        return [k, scores[k]];
      })
      .sort(function (a, b) {
        return b[1] - a[1];
      })
      .filter(function (e) {
        return e[1] > 0;
      });

    var recs = [{ product: 'foundation', score: scores.foundation, role: 'base' }];
    if (sorted.length > 0) recs.push({ product: sorted[0][0], score: sorted[0][1], role: 'primary' });
    if (sorted.length > 1 && sorted[1][1] >= 4)
      recs.push({ product: sorted[1][0], score: sorted[1][1], role: 'optional' });

    var stageOpt = QUIZ_QUESTIONS[0].options.find(function (o) {
      return o.value === answers.stage;
    });
    var cohort = stageOpt && stageOpt.cohort ? stageOpt.cohort : 'General';

    return { recs: recs, scores: scores, cohort: cohort };
  }

  /* ---- Blog article selection ---- */
  function generateArticlesIntro(articles) {
    var names = articles.map(function (a) {
      return a.name;
    });
    if (names.length === 0) return '';
    var nameText;
    if (names.length === 1) {
      nameText = names[0];
    } else if (names.length === 2) {
      nameText = names[0] + ' and ' + names[1];
    } else {
      nameText = names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
    }
    return (
      'Based on your quiz results, we think reading about ' + nameText + ' will be most helpful for you right now.'
    );
  }

  function selectBlogArticles() {
    var BLOG_BASE = 'https://themenopauseco.com/blogs/learn/tagged/';
    var priorityTags = [];

    function addTag(tag) {
      if (tag && priorityTags.indexOf(tag) === -1) priorityTags.push(tag);
    }

    // biggest_impact goes first — the user said this is their #1 issue
    addTag(IMPACT_TAG_MAP[answers.biggest_impact]);

    // Explicitly selected symptoms
    (answers.top_symptoms || []).forEach(function (sym) {
      addTag(SYMPTOM_TAG_MAP[sym]);
    });

    // Secondary signals from detail questions — only when they indicate a problem
    if (answers.sleep_quality && answers.sleep_quality !== 'good') addTag('Sleep');
    if (answers.energy_levels && answers.energy_levels !== 'good') addTag('Energy');
    if (answers.cognitive && answers.cognitive !== 'sharp') addTag('Brain Fog');
    if (answers.emotional && answers.emotional !== 'steady') addTag('Mood');
    if (answers.intimacy && answers.intimacy !== 'no_change' && answers.intimacy !== 'skip') addTag('Libido');

    // Stage-aware fallbacks to ensure at least 2 tags
    var stageFallbacks = {
      early_peri: 'Understanding Menopause',
      active_peri: 'Hormones',
      menopause: 'Hormones',
      post_meno: 'Wellness',
      unsure: 'Understanding Menopause',
    };
    var fallbackTags = [];
    if (stageFallbacks[answers.stage]) fallbackTags.push(stageFallbacks[answers.stage]);
    fallbackTags = fallbackTags.concat([
      'Natural Remedies',
      'Understanding Menopause',
      'Symptom Management',
      'Hormones',
      'Wellness',
    ]);

    if (priorityTags.length < 2) {
      fallbackTags.forEach(function (tag) {
        if (priorityTags.indexOf(tag) === -1 && priorityTags.length < 2) priorityTags.push(tag);
      });
    }

    return priorityTags.slice(0, 4).map(function (tag) {
      return {
        name: tag,
        url: BLOG_BASE + tag.toLowerCase().replace(/\s+/g, '-'),
        description: ARTICLE_DESCRIPTIONS[tag] || '',
      };
    });
  }

  /* ---- Personalised bullets ---- */
  function getPersonalizedBullets(productKey, ans) {
    var bullets = [];
    var symptoms = ans.top_symptoms || [];
    var biggest = ans.biggest_impact || '';
    var stage = ans.stage || '';
    var severity = parseInt(ans.severity, 10) || 5;
    var sleepQ = ans.sleep_quality || '';
    var energyQ = ans.energy_levels || '';
    var cogQ = ans.cognitive || '';
    var emotQ = ans.emotional || '';
    var intimQ = ans.intimacy || '';

    function has(sym) {
      return symptoms.indexOf(sym) !== -1;
    }

    if (productKey === 'foundation') {
      if (has('hot_flushes')) bullets.push('Targets the hot flushes you flagged as a key symptom');
      if (has('night_sweats')) bullets.push('May help reduce the night sweats disrupting your sleep');
      if (severity >= 7) bullets.push('Black cohosh may help ease symptom intensity when things feel most challenging');
      if (stage === 'early_peri' || stage === 'active_peri')
        bullets.push('Supports your body through the hormonal shifts of perimenopause');
      if (stage === 'menopause') bullets.push('Provides grounding hormonal support as your body navigates menopause');
      if (stage === 'post_meno') bullets.push('Offers continued hormonal balance for post-menopause wellbeing');
      bullets.push('Your essential base layer, works synergistically with every other formulation');
      bullets.push('Supports healthy hormone balance across all stages of menopause');
      bullets.push("Contains adaptogenic herbs that build your body's natural stress resilience");
    }

    if (productKey === 'mood') {
      if (has('mood_swings') || emotQ === 'swings') bullets.push('Directly targets the mood swings you told us about');
      if (has('anxiety') || emotQ === 'anxious')
        bullets.push("Saffron and lavender may ease the anxiety and overwhelm you've been feeling");
      if (emotQ === 'low') bullets.push("St. John's Wort may help lift the flat, low feeling you described");
      if (biggest === 'emotional')
        bullets.push('Addresses what you said is having the biggest impact on your daily life');
      if (cogQ === 'severe')
        bullets.push('Emotional balance can also support clearer thinking and reduced mental noise');
      bullets.push("Saffron, lavender, and St. John's Wort for a calmer, more balanced mood");
      bullets.push('May reduce irritability and support your sense of emotional steadiness');
      bullets.push('Green tea and folate provide nutritional support for healthy mood regulation');
    }

    if (productKey === 'sleep') {
      if (has('sleep_issues')) bullets.push("Formulated for the sleep disruption you've been experiencing");
      if (sleepQ === 'waking') bullets.push('Passionflower and hops may help you stay asleep through the night');
      if (sleepQ === 'onset') bullets.push('May help regulate your sleep cycle around your hormonal changes');
      if (sleepQ === 'unrefreshed')
        bullets.push('Targets sleep quality so you wake feeling genuinely rested, not just present');
      if (has('night_sweats')) bullets.push('Works alongside Foundation to reduce the night sweats waking you up');
      if (biggest === 'sleep') bullets.push('Directly addresses what you said is most disrupting your quality of life');
      if (energyQ === 'exhausted')
        bullets.push('Better sleep is the foundation of better energy, targets the root cause');
      bullets.push('Passionflower, California poppy, and magnesium for deeper, more restorative rest');
      bullets.push('May help you fall asleep faster and spend more time in restorative sleep stages');
    }

    if (productKey === 'libido') {
      if (intimQ === 'low_desire' || has('low_libido'))
        bullets.push('May help reawaken desire that has diminished during menopause');
      if (intimQ === 'dryness') bullets.push('Contains botanicals that may ease vaginal dryness and discomfort');
      if (intimQ === 'both') bullets.push('Supports both comfort and desire, addressing both changes you described');
      if (biggest === 'intimacy')
        bullets.push('Directly targets what you said is having the biggest impact on your daily life');
      if (emotQ === 'low' || emotQ === 'anxious')
        bullets.push('Emotional wellbeing and libido are deeply connected, pairs well with Mood');
      bullets.push('Natural botanicals to support intimate wellbeing through menopause');
      bullets.push('May support arousal, comfort, and reconnection with your body');
      bullets.push('These changes are incredibly common, and entirely possible to support naturally');
    }

    if (productKey === 'focus') {
      if (has('brain_fog')) bullets.push('Targeted at the brain fog you selected as one of your main symptoms');
      if (cogQ === 'moderate') bullets.push("Ginkgo biloba and bacopa may help with the memory lapses you've noticed");
      if (cogQ === 'severe')
        bullets.push('Formulated for when cognitive changes are affecting your confidence and performance');
      if (cogQ === 'mild') bullets.push('Helps maintain mental sharpness as hormonal changes begin to affect focus');
      if (biggest === 'cognitive')
        bullets.push('Addresses what you said is having the biggest impact on your daily life');
      if (energyQ === 'afternoon_crash')
        bullets.push('Mental clarity often dips alongside energy, Focus helps support both');
      bullets.push('Ginkgo biloba, bacopa, and schisandra to support memory and concentration');
      bullets.push('May help cut through hormonal brain fog and restore your cognitive confidence');
      bullets.push('Supports the kind of mental clarity that makes you feel like yourself again');
    }

    if (productKey === 'energy') {
      if (has('fatigue')) bullets.push("Formulated directly for the fatigue you've been experiencing");
      if (energyQ === 'afternoon_crash')
        bullets.push('Ashwagandha and guarana to tackle the afternoon energy crash you described');
      if (energyQ === 'exhausted')
        bullets.push('Supports your body when energy feels completely depleted from the moment you wake');
      if (energyQ === 'variable') bullets.push("Adaptogens help stabilise the 'wired but tired' pattern you described");
      if (sleepQ === 'unrefreshed')
        bullets.push("Supports sustained energy even when your sleep hasn't been fully restorative");
      if (biggest === 'energy') bullets.push('Directly targets what you said is most affecting your quality of life');
      bullets.push('Ashwagandha, Siberian ginseng, and CoQ10 for sustained vitality through the day');
      bullets.push('May support stamina so you can stop hitting that afternoon wall');
      bullets.push('Best taken in the morning, contains natural caffeine from guarana');
    }

    return bullets.slice(0, 4);
  }

  /* ---- Render ---- */
  function render() {
    var stepChanged = _prevStep !== currentStep;
    var qChanged = _prevStep === 'quiz' && _prevQIndex !== qIndex;
    var shouldScroll = stepChanged || qChanged;
    var enteringResults = _prevStep !== 'results' && currentStep === 'results';

    _prevStep = currentStep;
    _prevQIndex = qIndex;

    root.innerHTML = '';
    var container = h('div', { className: 'quiz-container' });

    // Progress bar (quiz + email steps only)
    if (currentStep === 'quiz' || currentStep === 'email') {
      var totalSteps = QUIZ_QUESTIONS.length + 1;
      var completedSteps = currentStep === 'email' ? QUIZ_QUESTIONS.length : qIndex;
      var pct = Math.round((completedSteps / totalSteps) * 100);
      container.appendChild(
        h(
          'div',
          { className: 'quiz-progress-wrap' },
          h('span', { className: 'quiz-progress-label' }, pct + '% complete'),
          h(
            'div',
            { className: 'quiz-progress' },
            h('div', { className: 'quiz-progress__bar', style: { width: pct + '%' } }),
          ),
        ),
      );
    }

    switch (currentStep) {
      case 'intro':
        container.appendChild(renderIntro());
        break;
      case 'quiz':
        container.appendChild(renderQuestion());
        break;
      case 'email':
        container.appendChild(renderEmail());
        break;
      case 'results':
        container.appendChild(renderResults());
        break;
    }

    root.appendChild(container);
    saveState();

    if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });

    if (currentStep === 'results') {
      setTimeout(function () {
        root.querySelectorAll('.quiz-rec-card__bar-fill[data-target-width]').forEach(function (el) {
          el.style.width = el.getAttribute('data-target-width');
        });
        var radar = root.querySelector('.quiz-radar');
        if (radar) radar.classList.add('is-animated');
      }, 150);

      if (enteringResults) {
        preloadOfferCode();
      }
    }
  }

  /* ---- Intro ---- */
  function renderIntro() {
    return h(
      'div',
      { className: 'quiz-step quiz-intro' },
      h(
        'h1',
        { className: 'quiz-heading quiz-heading--large' },
        'Find Your Perfect',
        h('br', null),
        'Menopause Support',
      ),
      h(
        'p',
        { className: 'quiz-subtitle' },
        "Answer a few questions about what you're experiencing, and we'll recommend the right combination of support, personalised to help you thrive.",
      ),
      h(
        'div',
        { className: 'quiz-intro__meta' },
        h('span', null, 'Takes about 2 minutes'),
        h('span', { className: 'quiz-intro__dot' }, '·'),
        h('span', null, 'No medical jargon'),
        h('span', { className: 'quiz-intro__dot' }, '·'),
        h('span', null, 'Completely private'),
      ),
      /* Sits above the CTA so the offer is read before the decision to start,
         not after it. Forward-looking copy — the quiz hasn't begun yet — and it
         states the purchase condition in full so the line stands on its own. */
      renderOfferCard({
        compact: true,
        text: "Complete the quiz and you'll receive a free product of your choice with your purchase. A bonus welcome gift, on us!",
      }),
      h(
        'button',
        {
          className: 'quiz-btn quiz-btn--cta is-pulsing',
          onClick: function () {
            clearState();
            currentStep = 'quiz';
            qIndex = 0;
            answers = {};
            email = '';
            isFirstOrder = false;
            results = null;
            render();
          },
        },
        h('span', null, "Let's Get Started"),
      ),
    );
  }

  /* Which purchase mode the radio cards have selected. Subscribe leads. */
  var selectedMode = 'subscribe';

  var money = function (n) {
    return '$' + n.toFixed(2);
  };

  /* Radio-card purchase picker, mirroring the product page's markup so both
     surfaces share assets/custom-tmc-purchase-options.css. That stylesheet is
     loaded for the quiz template in theme.liquid; its JS is not, because it
     exists to mirror the radio into Dawn's product form and the quiz has none —
     selection is handled here instead.

     Prices are plan totals after ADDEDFREE, struck through against the full
     one-time price of every recommendation, so the figure on the card is what
     the customer actually pays. */
  function renderPurchaseOptions(recs) {
    var n = recs.length;
    var rrp = n * PRICE_ONETIME;
    var subTotal = orderTotal(n, true);
    var oneTotal = orderTotal(n, false);
    var freeItem = freeIndex(recs) >= 0;

    function card(mode, title, total, benefits) {
      var isSelected = selectedMode === mode;
      /* Nothing is saved on a single-product one-time order, so a struck-through
         price identical to the payable one would be nonsense. */
      var showCompare = rrp - total > 0.005;

      return h(
        'div',
        {
          className: 'tmc-po__card tmc-po__card--' + mode + (isSelected ? ' is-selected' : ''),
          'data-tmc-po-card': mode,
          /* Toggle in place rather than re-rendering. A full render() would
             replay the match-strength bar animations on every switch. */
          onClick: function () {
            if (selectedMode === mode) return;
            selectedMode = mode;
            var root = document.querySelector('.quiz-po');
            if (!root) return;
            root.querySelectorAll('[data-tmc-po-card]').forEach(function (el) {
              var isSel = el.getAttribute('data-tmc-po-card') === mode;
              el.classList.toggle('is-selected', isSel);
              var input = el.querySelector('.tmc-po__input');
              if (input) input.checked = isSel;
            });
          },
        },
        mode === 'subscribe' ? h('span', { className: 'tmc-po__badge' }, 'Save 15%') : null,
        h('input', {
          className: 'tmc-po__input',
          type: 'radio',
          id: 'TmcPoQuiz-' + mode,
          name: 'TmcPoQuiz',
          checked: isSelected ? 'checked' : null,
          readonly: 'readonly',
        }),
        h(
          'label',
          { className: 'tmc-po__label', for: 'TmcPoQuiz-' + mode },
          h('span', { className: 'tmc-po__radio', 'aria-hidden': 'true' }),
          h('span', { className: 'tmc-po__title' }, title),
          h(
            'span',
            { className: 'tmc-po__price' },
            showCompare ? h('s', { className: 'tmc-po__compare' }, money(rrp)) : null,
            money(total),
          ),
        ),
        benefits && benefits.length
          ? h(
              'ul',
              { className: 'tmc-po__benefits' },
              benefits.map(function (text) {
                return h(
                  'li',
                  { className: 'tmc-po__benefit' },
                  h('span', { className: 'tmc-po__benefit-text' }, text),
                );
              }),
            )
          : null,
      );
    }

    var subBenefits = [];
    /* Whole dollars here — the price is round and "$69.00" reads like a total
       rather than the value of a gift. */
    if (freeItem) subBenefits.push('1 product free, worth $' + Math.round(PRICE_ONETIME));
    subBenefits.push('Save ' + money(firstOrderSaving(n, true)) + ' on your first order');
    subBenefits.push('No lock-in. Pause, skip or cancel anytime');
    subBenefits.push('60 day money back guarantee');

    return h(
      'div',
      { className: 'tmc-po quiz-po' },
      card('subscribe', 'Subscribe and save 15% — pause or cancel anytime', subTotal, subBenefits),
      card('onetime', 'One-time purchase', oneTotal, null),
    );
  }

  /* Shared offer card, used by the intro step and the results page. `compact`
     tightens the spacing and type for the intro, where it sits under the CTA
     rather than carrying a section of its own. */
  function renderOfferCard(opts) {
    return h(
      'div',
      { className: 'quiz-offer' + (opts.compact ? ' quiz-offer--compact' : '') },
      h(
        'h3',
        { className: 'quiz-offer__heading' },
        h('em', { className: 'quiz-offer__em' }, 'FREE'),
        ' product with your purchase',
      ),
      h('p', { className: 'quiz-offer__text' }, opts.text),
    );
  }

  /* ---- Question (single / multi) ---- */
  function renderQuestion() {
    var q = QUIZ_QUESTIONS[qIndex];
    if (q.type === 'slider') return renderSlider(q);

    var answer = answers[q.id];
    var isMulti = q.type === 'multi';
    var canProceed = isMulti ? Array.isArray(answer) && answer.length > 0 : !!answer;

    var optionEls = q.options.map(function (opt) {
      var selected = isMulti ? Array.isArray(answer) && answer.includes(opt.value) : answer === opt.value;

      return h(
        'button',
        {
          className: 'quiz-option' + (selected ? ' is-selected' : ''),
          'aria-checked': selected ? 'true' : 'false',
          role: isMulti ? 'checkbox' : 'radio',
          onClick: function (e) {
            if (isMulti) {
              var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
              var idx = cur.indexOf(opt.value);
              if (idx > -1) cur.splice(idx, 1);
              else cur.push(opt.value);
              answers[q.id] = cur;
              // Toggle just this button — no full re-render
              var nowSelected = cur.indexOf(opt.value) > -1;
              e.currentTarget.classList.toggle('is-selected', nowSelected);
              e.currentTarget.setAttribute('aria-checked', nowSelected ? 'true' : 'false');
              var ind = e.currentTarget.querySelector('.quiz-option__indicator');
              if (ind) ind.textContent = nowSelected ? '✓' : '';
              var continueBtn = root.querySelector('.quiz-btn--primary');
              if (continueBtn) {
                if (cur.length > 0) continueBtn.removeAttribute('disabled');
                else continueBtn.setAttribute('disabled', 'disabled');
              }
            } else {
              answers[q.id] = opt.value;
              // Update all sibling options — no full re-render
              var optionsEl = e.currentTarget.closest('.quiz-options');
              if (optionsEl) {
                optionsEl.querySelectorAll('.quiz-option').forEach(function (btn, i) {
                  var isSel = q.options[i] && q.options[i].value === opt.value;
                  btn.classList.toggle('is-selected', isSel);
                  btn.setAttribute('aria-checked', isSel ? 'true' : 'false');
                  var ind = btn.querySelector('.quiz-option__indicator');
                  if (ind) ind.textContent = isSel ? '✓' : '';
                });
              }
              var continueBtn = root.querySelector('.quiz-btn--primary');
              if (continueBtn) continueBtn.removeAttribute('disabled');
            }
            saveState();
          },
        },
        h(
          'span',
          { className: 'quiz-option__indicator' + (isMulti ? ' quiz-option__indicator--checkbox' : '') },
          selected ? '✓' : '',
        ),
        opt.label,
      );
    });

    return h(
      'div',
      { className: 'quiz-step' },
      h('p', { className: 'quiz-kicker' }, 'Question ' + (qIndex + 1) + ' of ' + QUIZ_QUESTIONS.length),
      h('h2', { className: 'quiz-heading' }, q.question),
      q.subtitle ? h('p', { className: 'quiz-subtitle' }, q.subtitle) : null,
      h('div', { className: 'quiz-options' }, optionEls),
      h(
        'div',
        { className: 'quiz-nav' },
        h(
          'button',
          {
            className: 'quiz-btn quiz-btn--secondary',
            onClick: function () {
              qIndex > 0 ? qIndex-- : (currentStep = 'intro');
              render();
            },
          },
          'Back',
        ),
        h(
          'button',
          {
            className: 'quiz-btn quiz-btn--primary',
            disabled: canProceed ? null : 'disabled',
            onClick: function () {
              var liveAnswer = answers[q.id];
              var liveProceed = isMulti ? Array.isArray(liveAnswer) && liveAnswer.length > 0 : !!liveAnswer;
              if (!liveProceed) return;
              qIndex < QUIZ_QUESTIONS.length - 1 ? qIndex++ : (currentStep = 'email');
              render();
            },
          },
          'Continue',
        ),
      ),
    );
  }

  /* ---- Slider question ---- */
  function renderSlider(q) {
    var currentVal = answers[q.id] !== undefined ? answers[q.id] : q.defaultValue;
    if (answers[q.id] === undefined) answers[q.id] = q.defaultValue;

    var initPct = ((currentVal - q.min) / (q.max - q.min)) * 100;
    var valueDisplay = h('div', { className: 'quiz-slider__value' }, String(currentVal));

    var sliderInput = h('input', {
      type: 'range',
      className: 'quiz-slider__input',
      min: String(q.min),
      max: String(q.max),
      step: '1',
      value: String(currentVal),
      'aria-label': q.question,
      onInput: function (e) {
        var val = parseInt(e.target.value, 10);
        answers[q.id] = val;
        valueDisplay.textContent = String(val);
        var pct = ((val - q.min) / (q.max - q.min)) * 100;
        e.target.style.setProperty('--slider-pct', pct + '%');
      },
    });
    sliderInput.style.setProperty('--slider-pct', initPct + '%');

    return h(
      'div',
      { className: 'quiz-step' },
      h('p', { className: 'quiz-kicker' }, 'Question ' + (qIndex + 1) + ' of ' + QUIZ_QUESTIONS.length),
      h('h2', { className: 'quiz-heading' }, q.question),
      q.subtitle ? h('p', { className: 'quiz-subtitle' }, q.subtitle) : null,
      h(
        'div',
        { className: 'quiz-slider' },
        valueDisplay,
        h('div', { className: 'quiz-slider__track-wrap' }, sliderInput),
        h('div', { className: 'quiz-slider__labels' }, h('span', null, q.labels.low), h('span', null, q.labels.high)),
      ),
      h(
        'div',
        { className: 'quiz-nav' },
        h(
          'button',
          {
            className: 'quiz-btn quiz-btn--secondary',
            onClick: function () {
              qIndex > 0 ? qIndex-- : (currentStep = 'intro');
              render();
            },
          },
          'Back',
        ),
        h(
          'button',
          {
            className: 'quiz-btn quiz-btn--primary',
            onClick: function () {
              qIndex < QUIZ_QUESTIONS.length - 1 ? qIndex++ : (currentStep = 'email');
              render();
            },
          },
          'Continue',
        ),
      ),
    );
  }

  /* ---- Email step ---- */
  function renderEmail() {
    var valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Create button first so onInput can reference it directly (avoids getElementById lookup)
    var submitBtn = h(
      'button',
      {
        className: 'quiz-btn quiz-btn--primary',
        disabled: !valid ? 'disabled' : null,
        onClick: function () {
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return;
          results = calculateResults();
          submitQuizToKlaviyo(results);
          currentStep = 'results';
          render();
        },
      },
      'See My Results',
    );

    var input = h('input', {
      type: 'email',
      className: 'quiz-email-input',
      placeholder: 'your@email.com',
      value: email,
      onInput: function (e) {
        email = e.target.value;
        if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) submitBtn.disabled = false;
        else submitBtn.disabled = true;
      },
    });

    var checkIndicator = h(
      'span',
      { className: 'quiz-checkbox-indicator' + (isFirstOrder ? ' is-checked' : '') },
      isFirstOrder ? '✓' : '',
    );
    var checkLabel = h(
      'div',
      {
        className: 'quiz-checkbox-label',
        onClick: function () {
          isFirstOrder = !isFirstOrder;
          render();
        },
      },
      checkIndicator,
      h('span', null, 'This will be my first order with The Menopause Co'),
    );

    var children = [
      h('p', { className: 'quiz-kicker' }, 'Almost there'),
      h('h2', { className: 'quiz-heading' }, 'Where should we send your personalised results?'),
      input,
      checkLabel,
      h(
        'p',
        { className: 'quiz-email-consent' },
        "We'll email your personalised plan straight away, plus the details of your free product offer. Also expect occasional tips, inspiration, and member-only offers — no spam, opt-out anytime.",
      ),
    ];

    /* Not gated on isFirstOrder: the offer is aimed at first-time customers but
       anyone may use it, so the title stays neutral rather than claiming a
       restriction that isn't enforced. */
    children.push(
      h(
        'div',
        { className: 'quiz-discount-banner' },
        h('p', { className: 'quiz-discount-banner__title' }, 'Get a FREE product'),
        h(
          'p',
          { className: 'quiz-discount-banner__text' },
          "After completing the quiz you'll receive a free product of your choice with any purchase — a bonus welcome gift, on us!",
        ),
      ),
    );

    // Nav
    var navChildren = [
      h(
        'button',
        {
          className: 'quiz-btn quiz-btn--secondary',
          onClick: function () {
            qIndex = QUIZ_QUESTIONS.length - 1;
            currentStep = 'quiz';
            render();
          },
        },
        'Back',
      ),
    ];

    navChildren.push(submitBtn);
    children.push(h('div', { className: 'quiz-nav' }, navChildren));

    return h('div', { className: 'quiz-step' }, children);
  }

  /* ---- Quiz Submission ---- */
  function buildEmailCartUrl(recs, subscribe) {
    var params = [];
    buildCartItems(recs, subscribe).forEach(function (item) {
      params.push('items[][id]=' + item.id);
      params.push('items[][quantity]=' + item.quantity);
      if (item.selling_plan) {
        params.push('items[][selling_plan]=' + item.selling_plan);
      } else {
        params.push('items[]');
      }
    });
    /* Land the emailed link on checkout, not /cart. With an offer, chain one
       more hop through Shopify's discount route first: it sets the
       discount_code cookie, which checkout reads, so ADDEDFREE arrives
       applied. */
    if (recs.length >= FREE_ITEM_MIN_COUNT) {
      params.push('return_to=/discount/' + DISCOUNT_CODE + '?redirect=/checkout');
    } else {
      params.push('return_to=/checkout');
    }
    var inner = '/cart/add?' + params.join('&');
    return 'https://themenopauseco.com/cart/clear?return_to=' + inner.replace(/&/g, '%26');
  }

  function submitQuizToKlaviyo(calcResults) {
    var articles = selectBlogArticles();
    var payload = {
      email: email,
      is_first_order: isFirstOrder,
      cohort: calcResults.cohort,
      quiz_answers: answers,
      scores: calcResults.scores,
      cart_url_subscribe: buildEmailCartUrl(calcResults.recs, true),
      cart_url_onetime: buildEmailCartUrl(calcResults.recs, false),
      subscription_savings: firstOrderSaving(calcResults.recs.length, true).toFixed(2),
      onetime_savings: firstOrderSaving(calcResults.recs.length, false).toFixed(2),
      offer_code: DISCOUNT_CODE,
      /* Lets the email gate its free-shipping line the same way the results
         page does, instead of restating the $99 rule in Klaviyo Liquid. */
      free_shipping: qualifiesForFreeShipping(calcResults.recs.length),
      free_product:
        calcResults.recs.length >= FREE_ITEM_MIN_COUNT ? calcResults.recs[calcResults.recs.length - 1].product : null,
      recommendations: calcResults.recs.map(function (rec) {
        return { product: rec.product, role: rec.role, score: rec.score };
      }),
      recommended_articles: articles,
      articles_intro: generateArticlesIntro(articles),
    };

    fetch('https://app.themenopauseco.com/quiz', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(function (err) {
      console.error('Quiz submission error:', err);
    });
  }

  /* ---- Radar Chart ---- */
  function renderRadarChart(scores) {
    var CX = 170,
      CY = 145,
      MAX_R = 90;
    var maxScore =
      Math.max(
        scores.foundation || 0,
        scores.mood || 0,
        scores.sleep || 0,
        scores.libido || 0,
        scores.focus || 0,
        scores.energy || 0,
      ) || 1;

    var axes = [
      { key: 'foundation', label: ['Hormone', 'Balance'], anchor: 'middle', lx: 170, ly: 39 },
      { key: 'mood', label: ['Mood &', 'Calm'], anchor: 'start', lx: 264, ly: 94 },
      { key: 'sleep', label: ['Sleep', 'Quality'], anchor: 'start', lx: 264, ly: 184 },
      { key: 'libido', label: ['Libido &', 'Comfort'], anchor: 'middle', lx: 170, ly: 239 },
      { key: 'focus', label: ['Mental', 'Clarity'], anchor: 'end', lx: 76, ly: 184 },
      { key: 'energy', label: ['Energy &', 'Vitality'], anchor: 'end', lx: 76, ly: 94 },
    ];

    /* Calculate SVG point for axis i at normalised value nv (0–1) */
    function pt(i, nv) {
      var angle = (Math.PI / 180) * (-90 + i * 60);
      var r = Math.min(Math.max(nv, 0), 1) * MAX_R;
      return {
        x: Math.round((CX + Math.cos(angle) * r) * 10) / 10,
        y: Math.round((CY + Math.sin(angle) * r) * 10) / 10,
      };
    }

    /* Points string for a concentric ring polygon at pct (0–1) of max radius */
    function ring(pct) {
      return [0, 1, 2, 3, 4, 5]
        .map(function (i) {
          var p = pt(i, pct);
          return p.x + ',' + p.y;
        })
        .join(' ');
    }

    /* Normalise a raw score against the highest score — top axis reaches outer ring */
    function norm(key) {
      return Math.max(scores[key] || 0, 0) / maxScore;
    }

    var outerPts = [0, 1, 2, 3, 4, 5].map(function (i) {
      return pt(i, 1);
    });

    /* Axis lines from centre to outer ring */
    var axisLines = outerPts
      .map(function (p) {
        return (
          '<line x1="' +
          CX +
          '" y1="' +
          CY +
          '" x2="' +
          p.x +
          '" y2="' +
          p.y +
          '" stroke="#ae6e41" stroke-width="0.75" stroke-opacity="0.18"/>'
        );
      })
      .join('');

    /* Data polygon points string */
    var dataPts = axes
      .map(function (a, i) {
        var p = pt(i, norm(a.key));
        return p.x + ',' + p.y;
      })
      .join(' ');

    /* Solid vertex dots at each data point */
    var vertexDots = axes
      .map(function (a, i) {
        var p = pt(i, norm(a.key));
        return '<circle cx="' + p.x + '" cy="' + p.y + '" r="5.5" fill="#ae6e41"/>';
      })
      .join('');

    /* Two-line axis labels using tspan for line breaks */
    var labelEls = axes
      .map(function (a) {
        return (
          '<text x="' +
          a.lx +
          '" y="' +
          a.ly +
          '" text-anchor="' +
          a.anchor +
          '"' +
          ' font-family="Manrope,sans-serif" font-size="11" font-weight="600" fill="#4a4424" opacity="0.90">' +
          '<tspan x="' +
          a.lx +
          '" dy="0">' +
          a.label[0] +
          '</tspan>' +
          '<tspan x="' +
          a.lx +
          '" dy="12">' +
          a.label[1] +
          '</tspan>' +
          '</text>'
        );
      })
      .join('');

    var svgStr =
      '<svg viewBox="0 0 340 280" role="img"' +
      ' aria-label="Radar chart showing your symptom profile across six wellness areas"' +
      ' xmlns="http://www.w3.org/2000/svg">' +
      '<defs>' +
      '<radialGradient id="tmc-radar-grad" cx="50%" cy="50%" r="50%">' +
      '<stop offset="15%" stop-color="#ae6e41" stop-opacity="0.52"/>' +
      '<stop offset="100%" stop-color="#ae6e41" stop-opacity="0.09"/>' +
      '</radialGradient>' +
      '</defs>' +
      /* Grid rings — 25/50/75/100% */
      '<polygon points="' +
      ring(0.25) +
      '" fill="none" stroke="#ae6e41" stroke-width="1" stroke-opacity="0.22" stroke-dasharray="3,4"/>' +
      '<polygon points="' +
      ring(0.5) +
      '" fill="none" stroke="#ae6e41" stroke-width="1" stroke-opacity="0.22" stroke-dasharray="3,4"/>' +
      '<polygon points="' +
      ring(0.75) +
      '" fill="none" stroke="#ae6e41" stroke-width="1" stroke-opacity="0.22" stroke-dasharray="3,4"/>' +
      '<polygon points="' +
      ring(1.0) +
      '" fill="none" stroke="#ae6e41" stroke-width="1.5" stroke-opacity="0.38"/>' +
      axisLines +
      labelEls +
      /* Animated data group — class targeted by CSS transition */
      '<g class="quiz-radar__data">' +
      '<polygon points="' +
      dataPts +
      '" fill="url(#tmc-radar-grad)" stroke="#ae6e41" stroke-width="2.5" stroke-linejoin="round"/>' +
      vertexDots +
      '</g>' +
      '</svg>';

    var wrap = h('div', { className: 'quiz-radar' });
    wrap.innerHTML = svgStr;
    return wrap;
  }

  /* ---- Results ---- */
  function renderResults() {
    var children = [];

    children.push(
      h(
        'div',
        { className: 'quiz-results__header' },
        h('p', { className: 'quiz-kicker', style: { color: 'inherit' } }, 'Your personalised results'),
        h('h2', { className: 'quiz-heading quiz-heading--large' }, 'Your Menopause Support Plan'),
        h('span', { className: 'quiz-results__cohort' }, results.cohort),
      ),
    );

    children.push(
      h(
        'p',
        { className: 'quiz-kicker', style: { color: 'inherit', textAlign: 'center', margin: '2rem 0 0.4rem' } },
        'Where you need the most support',
      ),
    );
    children.push(renderRadarChart(results.scores));
    children.push(
      h(
        'p',
        { className: 'quiz-kicker', style: { color: 'inherit', textAlign: 'center' } },
        "Here's what we'd recommend to help you thrive.",
      ),
    );

    var cards = h('div', { className: 'quiz-rec-cards' });
    results.recs.forEach(function (rec) {
      var product = PRODUCTS[rec.product];
      var badgeText = rec.role === 'base' ? 'Base Layer' : rec.role === 'primary' ? 'Top Match' : 'Additional Support';
      var badgeClass = 'quiz-rec-badge quiz-rec-badge--' + rec.role;
      var cardClass = 'quiz-rec-card quiz-rec-card--' + rec.role;
      var barColor = rec.role === 'base' ? 'var(--tmc-khaki)' : 'var(--tmc-caramel)';
      var barWidth = Math.min(100, Math.round((rec.score / 22) * 100));
      var strengthLabel = rec.score >= 10 ? 'Strong match' : rec.score >= 5 ? 'Good match' : 'Supporting match';

      var bullets = getPersonalizedBullets(rec.product, answers);
      var bulletList = h('ul', { className: 'quiz-rec-card__bullets' });
      bullets.slice(0, 3).forEach(function (text) {
        bulletList.appendChild(
          h(
            'li',
            { className: 'quiz-rec-card__bullet' },
            h('span', { className: 'quiz-rec-card__bullet-icon' }, '✓'),
            h('span', { className: 'quiz-rec-card__bullet-text' }, text),
          ),
        );
      });
      var bulletsWrap = h(
        'div',
        { className: 'quiz-rec-card__bullets-wrap' },
        h('p', { className: 'quiz-rec-card__bullets-heading' }, 'Why this works for you'),
      );
      bulletsWrap.appendChild(bulletList);

      cards.appendChild(
        h(
          'div',
          { className: cardClass },
          h(
            'div',
            { className: 'quiz-rec-card__top' },
            h(
              'div',
              { className: 'quiz-rec-card__image-wrap' },
              h('img', {
                className: 'quiz-rec-card__image',
                src: product.image,
                alt: 'The Menopause Co ' + product.name + ' supplement jar',
                loading: 'lazy',
                width: '200',
                height: '200',
              }),
            ),
            h(
              'div',
              { className: 'quiz-rec-card__body' },
              h('span', { className: badgeClass }, badgeText),
              h('h3', { className: 'quiz-rec-card__name' }, product.name),
              h('p', { className: 'quiz-rec-card__tagline' }, product.tagline),
              h('p', { className: 'quiz-rec-card__benefit' }, product.benefit),
              h(
                'div',
                { className: 'quiz-rec-card__bar-wrap' },
                h(
                  'div',
                  { className: 'quiz-rec-card__bar-track' },
                  h('div', {
                    className: 'quiz-rec-card__bar-fill',
                    style: { width: '0%', background: barColor },
                    'data-target-width': barWidth + '%',
                  }),
                ),
                h('p', { className: 'quiz-rec-card__strength' }, strengthLabel),
              ),
            ),
          ),
          h(
            'div',
            { className: 'quiz-rec-card__footer' },
            bulletsWrap,
            h(
              'a',
              {
                className: 'quiz-btn quiz-btn--shop',
                href: '/products/' + product.handle,
              },
              'Learn more about ' + product.name + ' →',
            ),
          ),
        ),
      );
    });
    children.push(cards);

    var free = freeProduct(results.recs);

    if (free) {
      children.push(
        renderOfferCard({
          text: 'Your plan qualifies for one formulation on us, applied automatically at checkout.',
        }),
      );
    }

    var trustSignals = [];
    if (qualifiesForFreeShipping(results.recs.length))
      trustSignals.push(h('span', { className: 'quiz-trust-signal' }, 'Free shipping on this order'));
    if (isFirstOrder) trustSignals.push(h('span', { className: 'quiz-trust-signal' }, '60-day risk-free trial'));

    children.push(
      h(
        'div',
        { className: 'quiz-results__cta' },
        trustSignals.length > 0 ? h('div', { className: 'quiz-trust-signals' }, trustSignals) : null,
        h(
          'div',
          { className: 'quiz-sub-benefits' },
          h(
            'button',
            {
              className: 'quiz-sub-benefits__toggle',
              'aria-expanded': 'false',
              onClick: function (e) {
                var btn = e.currentTarget;
                var panel = btn.nextElementSibling;
                var isOpen = btn.getAttribute('aria-expanded') === 'true';
                btn.setAttribute('aria-expanded', String(!isOpen));
                btn.classList.toggle('is-open', !isOpen);
                panel.classList.toggle('is-open', !isOpen);
              },
            },
            'Benefits of subscribing',
            h('span', { className: 'quiz-sub-benefits__chevron', 'aria-hidden': 'true' }),
          ),
          h(
            'div',
            { className: 'quiz-sub-benefits__panel', role: 'region' },
            h(
              'ul',
              { className: 'quiz-sub-benefits__list' },
              h('li', null, '15% Off Every Month'),
              h('li', null, 'Skip or Cancel Anytime'),
              h('li', null, 'Compostable Refill Pouches'),
              h('li', null, 'Swap Products as Symptoms Change'),
              h('li', null, 'Stress-Free Deliveries'),
              h('li', null, 'Stay on Track With Your Wellness Growth'),
            ),
            h('p', { className: 'quiz-sub-benefits__tagline' }, 'Stay Consistent. See Results. Save 15% Every Month.'),
            h(
              'p',
              { className: 'quiz-sub-benefits__sub' },
              'Start your Menopause wellness journey today from less than $2.00 a day.',
            ),
          ),
        ),
        renderPurchaseOptions(results.recs),
        h(
          'button',
          {
            className: 'quiz-btn quiz-btn--cta',
            id: 'quiz-add-to-cart',
            onClick: function () {
              addRecommendationsToCart(selectedMode === 'subscribe');
            },
          },
          h('span', null, 'Add to cart'),
          h('span', { className: 'quiz-spinner' }),
        ),
        h(
          'button',
          {
            className: 'quiz-results__retake',
            onClick: function () {
              clearState();
              currentStep = 'intro';
              qIndex = 0;
              answers = {};
              email = '';
              isFirstOrder = false;
              results = null;
              render();
            },
          },
          'Retake the quiz',
        ),
      ),
    );

    return h('div', { className: 'quiz-step quiz-results' }, children);
  }

  /* ---- Add to cart ---- */
  function addRecommendationsToCart(subscribe) {
    /* One button for both modes now — the radio cards carry the choice. */
    var btnId = 'quiz-add-to-cart';
    var btn = document.getElementById(btnId);
    if (!btn || btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');

    var cartItems = buildCartItems(results.recs, subscribe);

    fetch('/cart/clear.js', { method: 'POST' })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify({ items: cartItems }),
        });
      })
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        /* Apply ADDEDFREE after the add so the drawer refresh below reflects it. */
        if (cartItems.length < FREE_ITEM_MIN_COUNT) return response;
        return applyOfferCode().then(function () {
          return response;
        });
      })
      .then(function (response) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quiz', cartData: response });
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch('/?sections=cart-drawer')
            .then(function (r) {
              return r.json();
            })
            .then(function (sections) {
              var drawerEl = document.getElementById('CartDrawer');
              if (drawerEl && sections['cart-drawer']) {
                var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
                var newContent = parsed.querySelector('#CartDrawer');
                if (newContent) drawerEl.innerHTML = newContent.innerHTML;
              }
              var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
              if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
              cartDrawer.open();
            });
        }
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
      })
      .finally(function () {
        if (btn) btn.classList.remove('is-loading');
      });
  }

  /* ---- Init ---- */
  render();
})();
